//component
import ModalMaster from "@/components/Modal/ModalMaster.vue";
//store
import ModalStore from '@/store/ModalStore';
//modal controller
import { ModalController } from '@/components/Modal/ModalController.js';
import { AlertModalController } from '@/components/Modal/Generic/AlertModal/AlertModalController';
import { ConfirmModalController } from '@/components/Modal/Generic/ConfirmModal/ConfirmModalController';
import { LoadingModalController } from '@/components/Modal/Generic/LoadingModal/LoadingModalController';
import { ConfirmRedeemModalController } from '@/module/Detail/modal/ConfirmRedeemModal/ConfirmRedeemModalController';
import { SerialModalController } from '@/module/Detail/modal/SerialModal/SerialModalController';
import { CopySerialSuccessModalController } from "@/module/Detail/modal/SerialModal/CopySerialSuccessModalController";
import { VerifyCodeModalController } from "@/module/Detail/modal/VerifyCodeModal/VerifyCodeModalController";
import { DrawDeliveryModalController } from '@/module/Detail/modal/DrawDeliveryModal/DrawDeliveryModalController';
import { ShippingAddressModalController } from '@/module/Detail/modal/ShippingAddressModal/ShippingAddressModalController';
import { AddAddressModalController } from '@/module/Address/DeliveryAddress/modal/AddAddressModal/AddAddressModalController';
import { EditAddressModalController } from '@/module/Address/DeliveryAddress/modal/EditAddressModal/EditAddressModalController';
import { ListAddressModalController } from '@/module/Address/DeliveryAddress/modal/ListAddressModal/ListAddressModalController';
import { AddTaxAddressModalController } from '@/module/Address/TaxAddress/modal/AddTaxAddressModal/AddTaxAddressModalController';
import { EditTaxAddressModalController } from '@/module/Address/TaxAddress/modal/EditTaxAddressModal/EditTaxAddressModalController';
import { ListTaxAddressModalController } from '@/module/Address/TaxAddress/modal/ListTaxAddressModal/ListTaxAddressModalController';
import { OtpModalController } from '@/components/Modal/Otp/OtpModalController';
import { RegisterSuccessModalController } from '@/module/Register/modal/RegisterSuccessModal/RegisterSuccessModalController';
import { MarketingOptionModalController } from '@/components/Modal/Terms/MarketingOptionModal/MarketingOptionModalController';
import { NoInternetModalController } from '@/components/Modal/Generic/NoInternetModal/NoInternetModalController';
import { DeliveryStatusModalController } from '@/module/History/modal/DeliveryStatusModal/DeliveryStatusModalController';
import { ErrorModalController } from '@/components/Modal/Generic/ErrorModal/ErrorModalController';
import { CopySuccessModalController } from "@/module/History/modal/CopyCodeModal/CopySuccessModalController";
import { FreeStarbuckModalController } from "@/module/History/modal/FreeStarbuckModal/FreeStarbuckModalController";
import { MissionAlertModalController } from "@/module/Mission/modal/MissionAlertModal/MissionAlertModalController";
import { MissionConfirmModalController } from "@/module/Mission/modal/MissionConfirmModal/MissionConfirmModalController";

export default {
    provide: {
        ModalStore: ModalStore,
    },
    components: {
        ModalMaster,
    },
    data: function () {
        return {
            modalController: null,
        };
    },
    created: function () {
        this.initModal();
        this.connectModal();
        ModalStore.methods.setModalController(this.modalController);
    },
    methods: {
        initModal: function () {
            this.modalController = new ModalController();
            //Generic
            this.modalController.setAlertModal(new AlertModalController());
            this.modalController.setConfirmModal(new ConfirmModalController());
            this.modalController.setLoadingModal(new LoadingModalController());
            this.modalController.setNoInternetModal(new NoInternetModalController());
            this.modalController.setErrorModal(new ErrorModalController());
            //Redeem
            this.modalController.setConfirmRedeemModal(new ConfirmRedeemModalController());
            this.modalController.setSerialModal(new SerialModalController());
            this.modalController.setDrawDeliveryModal(new DrawDeliveryModalController());
            this.modalController.setShippingAddressModal(new ShippingAddressModalController());
            this.modalController.setCopySerialSuccessModal(new CopySerialSuccessModalController());
            this.modalController.setVerifyCodeModal(new VerifyCodeModalController());
            //Address
            this.modalController.setAddAddressModal(new AddAddressModalController());
            this.modalController.setEditAddressModal(new EditAddressModalController());
            this.modalController.setListAddressModal(new ListAddressModalController());
            //Tax
            this.modalController.setAddTaxAddressModal(new AddTaxAddressModalController());
            this.modalController.setEditTaxAddressModal(new EditTaxAddressModalController());
            this.modalController.setListTaxAddressModal(new ListTaxAddressModalController());
            //Other core modal
            this.modalController.setOtpModal(new OtpModalController());
            this.modalController.setRegisterSuccessModal(new RegisterSuccessModalController());
            this.modalController.setMarketingOptionModal(new MarketingOptionModalController());
            //history
            this.modalController.setDeliveryStatusModal(new DeliveryStatusModalController());
            this.modalController.setCopySuccessModal(new CopySuccessModalController());
            this.modalController.setFreeStarbuckModal(new FreeStarbuckModalController());
            //mission
            this.modalController.setMissionAlertModal(new MissionAlertModalController());
            this.modalController.setMissionConfirmModal(new MissionConfirmModalController());
        },
        connectModal: function () {
            //addAddressModal
            this.modalController.addAddressModal.setAlertModal(this.modalController.alertModal);
            this.modalController.addAddressModal.setLoadingModal(this.modalController.loadingModal);
            //editAddressModal
            this.modalController.editAddressModal.setAlertModal(this.modalController.alertModal);
            this.modalController.editAddressModal.setLoadingModal(this.modalController.loadingModal);
            //listAddressModal
            this.modalController.listAddressModal.setAlertModal(this.modalController.alertModal);
            this.modalController.listAddressModal.setConfirmModal(this.modalController.confirmModal);
            this.modalController.listAddressModal.setLoadingModal(this.modalController.loadingModal);
            this.modalController.listAddressModal.setAddAddressModal(this.modalController.addAddressModal);
            this.modalController.listAddressModal.setEditAddressModal(this.modalController.editAddressModal);
            //addTaxAddressModal
            this.modalController.addTaxAddressModal.setAlertModal(this.modalController.alertModal);
            this.modalController.addTaxAddressModal.setLoadingModal(this.modalController.loadingModal);
            //editTaxAddressModal
            this.modalController.editTaxAddressModal.setAlertModal(this.modalController.alertModal);
            this.modalController.editTaxAddressModal.setLoadingModal(this.modalController.loadingModal);
            //listTaxAddressModal
            this.modalController.listTaxAddressModal.setAlertModal(this.modalController.alertModal);
            this.modalController.listTaxAddressModal.setConfirmModal(this.modalController.confirmModal);
            this.modalController.listTaxAddressModal.setLoadingModal(this.modalController.loadingModal);
            this.modalController.listTaxAddressModal.setAddAddressModal(this.modalController.addTaxAddressModal);
            this.modalController.listTaxAddressModal.setEditAddressModal(this.modalController.editTaxAddressModal);
            //deliveryStatusModal
            this.modalController.deliveryStatusModal.setCopySuccessModal(this.modalController.copySuccessModal);
        },
    }
}
